__webpack_require__.p = "/mi-assets/mi-static/mi-shop-renderer-spa/phx-rel-R24.11.2-8NOV20244PMIST/_next/";